import { render, staticRenderFns } from "./CopyRight.vue?vue&type=template&id=bce36cb2&scoped=true"
import script from "./CopyRight.vue?vue&type=script&lang=js"
export * from "./CopyRight.vue?vue&type=script&lang=js"
import style0 from "./CopyRight.vue?vue&type=style&index=0&id=bce36cb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bce36cb2",
  null
  
)

export default component.exports